export const kanjiPredictionConstants = {
  MODEL_KEY: 'kanjiPrediction',
  MODEL_KEY_DL: 'kanji-recognizer',
  MODEL_INPUT_WIDTH: 64,
  MODEL_INPUT_HEIGHT: 64,
  MIN_CONFIDENCE: 0.005,
};
